<template>
  <div style="display: flex;flex-wrap: wrap;">
    <div class="fileList" v-for="(item, index) in files" :key="index">
      <div style="height: 60px;">
        <img v-if="item.suffix == 'png' || item.suffix == 'jpg' || item.suffix == 'jpeg'" class="file-icon"
             src="@/assets/images/img.png" alt="" srcset=""/>
        <img v-else-if="item.suffix == 'docx'" class="file-icon" src="@/assets/images/docx.png" alt=""
             srcset=""/>
        <img v-else-if="item.suffix == 'pdf'" class="file-icon" src="@/assets/images/pdf.png" alt=""
             srcset=""/>
        <img v-else-if="item.suffix == 'pptx' || item.suffix == 'ppt'" class="file-icon"
             src="../assets/images/pptx.png" alt="" srcset=""/>
        <img v-else-if="item.suffix == 'xlsx'" class="file-icon" src="@/assets/images/xlsx.png" alt=""
             srcset=""/>
        <img v-else-if="item.suffix == 'txt'" class="file-icon" src="@/assets/images/txt.png" alt=""
             srcset=""/>
        <img v-else-if="item.suffix == 'mp4'" class="file-icon" src="@/assets/images/mp4.png" alt=""
             srcset=""/>
        <img v-else class="file-icon" src="@/assets/images/wj.png" alt="" srcset=""/>
        <div>
          <div class="file-path">{{ item.name }}</div>
          <div class="file-path">{{ (Number(item.size) / 1024).toFixed(1) }}kb</div>
        </div>
      </div>
      <div style="height: 40px;border-top: 1px solid #e1eee1;">
        <div v-if="!readonly" class="file-del" @click="filedel(index)">删除</div>
        <div style="display: flex;justify-content: flex-start;">
          <div class="file-look" @click="filelook(item.suffix, item.path)">查看</div>
        </div>
      </div>
    </div>
    <el-upload v-if="!readonly && files.length < limit" class="avatar-uploader" :multiple="true"
               :action="upAction" :on-success="handleSuccess"
               :headers="{'token':token}"
               list-type="picture-card" :file-list="files">
      <div style="display: flex;justify-content: center;align-items: center;line-height: 100px;">
<!--        <el-icon :size="30">-->
          <i class="el-icon-circle-plus"></i>
<!--        </el-icon>-->
        <div style="margin-left: 10px;">添加文件</div>
      </div>
    </el-upload>
  </div>

</template>

<script>
export default {
  name: "CommUpload",
  components: {
  },
  props: {
    files: {
      type: Array,
      default: ()=>[]
    },
    readonly:  {
      type: Boolean,
      default: false
    },
    limit:  {
      type: Number,
      default: 100
    }
  },
  data() {
    let token = localStorage.getItem("token")
    return {
      token:token,
      dialogImageUrl: false,
      dialogVisible: false,
      baseApi: this.$store.state.ossUrl,
      upAction: this.$store.state.uploadingUrl,

    };
  },
  onShow() {
  },
  methods: {
    handleSuccess(response, uploadFile) {
      if (response) {
        console.log('response',response)
        let imgVal = {name: '', path: '', suffix: '', size: 0}
        imgVal.name = uploadFile.name
        imgVal.path = response.data
        imgVal.size = uploadFile.size
        imgVal.suffix = response.data.substr(response.data.lastIndexOf(".") + 1)
        this.files.push(imgVal)
        this.$emit('clk', this.files)
        console.log('----传值给父组件-----', this.files)
      } else {
        this.$message.error('上传失败，请重试')
      }
    },
    filelook(suffix, url) {
      window.open(this.baseApi + url)
    },
    filedel(index) {
      this.files.splice(index, 1)
      this.$emit('clk', this.files)
    }
  }
};
</script>

<style scoped>
/deep/ .el-upload {
  border: 1px solid #e9e9e9;
  background: transparent;
  width: auto !important;
  height: 100px !important;
  box-sizing: border-box;
  padding: 0 60px;
  margin: 5px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.remark {
  margin-top: 100px;
  font-size: 13px;
}

/deep/ .is-success {
  display: none;
}

.fileList {
  width: 218px;
  height: 100px;
  border: 1px solid #e9e9e9;
  background: transparent;
  box-sizing: border-box;
  padding: 0 10px;
  font-size: 14px;
  margin: 5px;
  border-radius: 6px;
}

.fileList > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.file-icon {
  width: 40px;
  height: 40px;
}

.file-down {
  margin-left: 5px;
}

.file-down,
.file-del,
.file-look {
  cursor: pointer;
}

.file-path {
  width: 130px;
  line-height: 20px;
  text-align: end;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
}

/deep/ .el-dialog {
  background: transparent;
  box-shadow: none;
}

/deep/ .el-dialog__body {
  display: flex;
  justify-content: center;
  align-items: center;
}

/deep/ .el-dialog svg {
  color: #fff;
}
</style>
